class UpdateNewsletterController {
    /*@ngInject*/
    constructor() {
        this.requestPending = false;
        this.frequencyStandard = false;
        this.frequencyMonthly = false;
    }

    frequencyChanged(type) {
        if (type == 'standard') {
            this.frequencyMonthly = false;
        } else {
            this.frequencyStandard = false;
        }
    }

    init(frequencyStandard, frequencyMonthly) {
        this.frequencyStandard = frequencyStandard;
        this.frequencyMonthly = frequencyMonthly;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default UpdateNewsletterController;
